/*jslint browser: true, fudge: true, long: true */
/*global $, blacksunplc, document, window, AOS */

blacksunplc.events.ready(function () {
    "use strict";
    var navigationWrapper = $(".main-nav");
    var windowWidth = $(window).width();

    $(".hamburger").on("click", function (event) {
        event.stopPropagation();
        var button = $(event.currentTarget);
        button.toggleClass("is-active");
        navigationWrapper.toggleClass("is-active");
        $("body").toggleClass("menu-open");
    });

    function closeNavigation() {
        $(".hamburger").removeClass("is-active");
        navigationWrapper.removeClass("is-active");
        $("body").removeClass("menu-open");
    }

    navigationWrapper.on("click", ".main-nav__close", function (event) {
        event.preventDefault();
        closeNavigation();
    });

    navigationWrapper.on("click", function (event) {
        event.stopPropagation();
    });

    $(document).on("click", function () {
        closeNavigation();
    });

    if ($("body").hasClass("homepage")) {
        $("body").addClass("overflow-hidden");
    }

    $(".parent > a").on("click", function (e) {
        e.preventDefault();

        $(this).parent().addClass("show-sublinks");
    });

    $(".back").on("click", function (e) {
        e.preventDefault();
        $(".show-sublinks").removeClass("show-sublinks");
    });

    var parent;

    $("body").on("click", ".mobile-accordion h2", function () {
        parent = $(this).parent();
        $(this).parent().toggleClass("expand");


        scrollToElement(parent, 55);
        setTimeout(function () {
            handleHeights();
        }, 500);
        return false;
    });

    function mobileAccordion() {
        windowWidth = $(window).width();
        if ($(".mobile-accordion").length) {
            if (windowWidth > 840) {
                $(".mobile-accordion *").css("display", "");
                $(".mobile-accordion .row").css("display", "flex");
                $(".mobile-accordion").removeClass("expand");
            } else {
                $(".mobile-accordion .row").css("display", "");
            }
        }
    }

    function homepage() {
        if ($(".homepage .message").length) {
            if (windowWidth > 840) {
                var titleH = 0;

                $(".homepage .message .title").each(function () {
                    $(".homepage .message .title").css("height", "");
                    if ($(this).outerHeight() > titleH) {
                        titleH = $(this).outerHeight();
                    }
                    $(".homepage .message .title").css("height", titleH);
                });
            }
        }
    }

    function progressingPage() {
        if ($(".tile-row .tile h6").length) {
            if (windowWidth > 840) {
                var titleH = 0;

                $(".tile-row .tile h6").each(function () {
                    $(".tile-row .tile h6").css("height", "");
                    if ($(this).outerHeight() > titleH) {
                        titleH = $(this).outerHeight();
                    }
                    $(".tile-row .tile h6").css("height", titleH);
                });
            }
        }
    }

    function scrollToElement(element, topSpacing) {
        if (windowWidth < 841) {
            topSpacing = 190;
        }
        $("html, body").animate({
            scrollTop: element.offset().top - topSpacing
        }, 500);
    }

    function gotoSectionNavigaion() {
        $(".page-body__navigation").on("click", "a", function (event) {
            event.preventDefault();
            var anchore = $(event.currentTarget);
            var id = anchore.attr("href");
            if ($(id).parents(".bs-accordion").length) {
                var accButton = id.replace("#", "");
                var button = $(".bs-accordion__header button[aria-controls=" + accButton + "]");
                button.trigger("click");
                setTimeout(function () {
                    scrollToElement(button, 70);
                }, 300);
            } else {
                scrollToElement($(id), 150);
            }
        });
    }

    function resizeGallery() {
        if (windowWidth > 820) {
            $(".pillar__gallery").each(function () {
                var titleHeight = 0;
                var outerHeight = 0;

                $(this).find("h6").each(function () {
                    outerHeight = $(this).outerHeight();
                    if (outerHeight > titleHeight) {
                        titleHeight = outerHeight;
                    }
                });

                $(this).find("h6").css("height", titleHeight + "px");
            });
        }
    }

    function resizeGalleryImage() {
        if (windowWidth > 820) {
            $(".pillar__gallery").each(function () {
                var imgHeight = 0;
                var outerImageHeight = 0;

                $(this).find(".img-container").each(function () {
                    outerImageHeight = $(this).outerHeight();

                    if (outerImageHeight > imgHeight) {
                        imgHeight = outerImageHeight;
                    }
                });

                $(this).find(".img-container").css("height", imgHeight + "px");
            });
        }
    }

    function dividendCart() {
        if (windowWidth > 820) {
            var itemHeight = 0;
            $(".dividends-chart .item li").each(function () {

                var outerHeight = $(this).outerHeight();
                if (outerHeight > itemHeight) {
                    itemHeight = outerHeight;
                }

            });
            $(".dividends-chart .item li").css("height", itemHeight + "px");
        }
    }

    function resizeNumericValues() {
        if ($(".numeric-values .flex").length > 0) {
            var contHeight = 0;
            var parent;
            var firstChild;
            if (windowWidth > 767) {
                $(".numeric-values .flex").each(function () {
                    contHeight = 0;
                    parent = $(this);
                    firstChild = parent.find(".value-item:first-child");

                    firstChild.css("height", "");
                    firstChild.each(function () {
                        if ($(this).outerHeight() > contHeight) {
                            firstChild.height($(this).outerHeight() + "px");
                        }
                    });
                });
            } else {
                $(".numeric-values .flex .value-item").css("height", "");
            }
        }
    }

    function sustainabilityTables() {
        if (windowWidth > 840) {
            var headingHeight = 0;
            var currHeight;;

            $(".abc h3").each(function () {
                currHeight = $(this).outerHeight();
                if (currHeight > headingHeight) {
                    headingHeight = currHeight;
                }
            });

            $(".abc h3").css("height", headingHeight + "px");
        }
    }

    function handleNavOnScroll() {
        var top = $(document).scrollTop();

        if (top > 0) {
            $("body").addClass("scrolling");
        } else {
            $("body").removeClass("scrolling");
        }
    }

    function handleSideNav(sectionId) {
        if (sectionId === undefined) {
            $(".page-body__content section").each(function () {
                if ($(this).isInViewportSidenav()) {
                    sectionId = $(this).attr("id");
                }
            });

            $(".page-body__navigation a").removeClass("active");

            $(".page-body__navigation a").each(function () {
                if ($(this).attr("href") == "#" + sectionId) {
                    $(this).addClass("active");
                }
            });
        }
    }

    $.fn.isInViewportSidenav = function () {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();

        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height() - 500;

        return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    $.fn.isInViewport = function () {
        var elementTop = $(this).offset().top;
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        if ($(this).hasClass("animate-sequence")) {
            viewportBottom = viewportTop;


        }
        return elementTop >= viewportTop && elementTop <= viewportBottom;
    };

    function isElementInView(element) {
        var $el = $(element);
        var elementTop = $el.offset().top;
        var elementBottom = elementTop + $el.outerHeight();
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        return elementBottom > viewportTop && elementTop < viewportBottom;
    }

    function handleHomeBanner() {
        var bannerSection = $(".hm-banner");
        var preload = $(".hm-banner__preload");
        var mainBanner = $(".hm-banner__main");

        if (bannerSection.length == 0) {
            return;
        }

        $("html, body").animate({ scrollTop: 0 }, 0);

        $(".enter-site").on("click", function (e) {
            e.preventDefault();
            window.scrollTo(0, 0);

            setTimeout(function () {
                preload.fadeOut();
                mainBanner.addClass("show");
                $("body").removeClass("overflow-hidden");
            }, 500);
        });

        $(".hm-banner .arrow-down").on("click", function (e) {
            e.preventDefault();
            scrollToElement($("#main"), 100);
        });
    }

    function handleAIPage() {
        if ($(".creating-value-through-ai").length > 0) {
            var height = 0;
            $(".ai-tiles .bottom-section").each(function () {
                if ($(this).outerHeight() > height) {
                    height = $(this).outerHeight();
                }
            });

            $(".ai-tiles .bottom-section").css("height", height + "px");
        }
    }

    function setupAnimatedValues() {
        $(".count").each(function () {
            var countValue = $(this).text().replace(",", "");
            $(this).attr("data-val", countValue);
            $(this).text("0");
        });
    }

    function animateValues() {
        $(".count").each(function () {
            if (!$(this).hasClass("animated")) {
                var element = this;
                var observer = new IntersectionObserver(function (entries) {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting) {
                            $(element).prop('Counter', 0).animate({
                                Counter: $(element).attr("data-val")
                            }, {
                                duration: 500,
                                easing: 'swing',
                                step: function (now) {
                                    if ($(element).hasClass("decimal")) {
                                        if ($(element).hasClass("decimal-0")) {
                                            $(element).text((Math.ceil(now * 10) / 10).toFixed(1));
                                        } else {
                                            $(element).text(Math.ceil(now * 100) / 100);
                                        }
                                    } else {
                                        $(element).text(Math.ceil(now).toLocaleString());
                                    }
                                }
                            });
                            $(element).addClass("animated");
                            observer.unobserve(element);
                        }
                    });
                });
                observer.observe(element);
            }
        });

    }

    var scrollPos = $(window).scrollTop();

    if ($(".page-body__navigation").length > 0) {
        var sideNavPos = $(".page-body__navigation").offset().top - 190;
        var activeText = $(".page-body__navigation ul li:first-child a").text();
    }
    function handleMobileStickySideNav() {
        scrollPos = $(window).scrollTop();
        windowWidth = $(window).width();

        if ($(".active-nav").length == 0 && windowWidth < 841) {
            $(".page-body__navigation ul").prepend("<li class='active-nav'>" + activeText + "</li>");
        }

        if (windowWidth < 841) {
            if (scrollPos >= sideNavPos) {
                $("body").addClass("stickyNav");
                $(".page-body__navigation").appendTo("header");
            } else {
                $("body").removeClass("stickyNav");
                $(".page-body__navigation").insertBefore(".page-body");
            }
        } else {
            $("body").removeClass("stickyNav");
            $(".page-body__navigation").prependTo(".page-body")
        }
    }

    function handleStickySideNavToggle() {
        $(".page-body__navigation").on("click", function () {
            $(this).toggleClass("expand");
        });

        $(".page-body__navigation a").on("click", function () {
            activeText = $(this).text();
            var accordion = $(this).attr("href");

            if (windowWidth < 841) {
                $(".page-body__navigation .active-nav").text(activeText);
                if (!$(accordion).hasClass("expand")) {
                    $(accordion).find("h2").trigger("click");
                }
            }
        });

    }

    function handleHeights() {
        var parHeight = 0;
        $(".border-divider p").css("height", "");

        if (windowWidth > 840) {
            $(".border-divider").each(function () {
                parHeight = 0;

                $(this).find("p:first-child").each(function () {
                    if ($(this).outerHeight() > parHeight) {
                        parHeight = $(this).outerHeight();
                    }
                });

                $(this).find("p:first-child").css("height", parHeight + "px");
            });
        } else {
            $("#record-financial-results .border-divider").each(function () {
                parHeight = 0;

                $(this).find("p:first-child").each(function () {
                    if ($(this).outerHeight() > parHeight) {
                        parHeight = $(this).outerHeight();
                    }
                });

                $(this).find("p:first-child").css("height", parHeight + "px");
            });
        }

        var container = $(".equal-height");

        if (container.length > 0 && windowWidth > 767) {
            container.each(function () {
                var headings = $(this).find(".heading");
                var maxHeight = 0;

                headings.css("height", "");

                headings.each(function () {
                    if ($(this).outerHeight() > maxHeight) {
                        maxHeight = $(this).outerHeight();
                    }
                });

                headings.css("height", maxHeight + "px");
            });
        }

        var sustainabilityBoxes = $(".sustainability-boxes");

        if (sustainabilityBoxes.length > 0 && windowWidth > 767) {
            sustainabilityBoxes.each(function () {
                var headings = $(this).find(".writeup > div:first-child");
                var maxHeight = 0;
                headings.css("height", "");

                headings.each(function () {
                    if ($(this).outerHeight() > maxHeight) {
                        maxHeight = $(this).outerHeight();
                    }
                });
                headings.css("height", maxHeight + "px");
            });
        }

    }

    function handleSlideUpAnimation() {
        $(".animate-content >*:not(section):not(.animate-sequence), .animate-content >*:not(.animate-sequence) >*").each(function () {
            if ($(this).isInViewport() && !$(this).hasClass("slide-up") && !$(this).hasClass("no-animation") && !$(this).hasClass("row")) {
                $(this).addClass("slide-up");
            }
        });

        $(".animate-sequence").each(function () {
            var element = this;
            if (!$(element).hasClass("animated")) {
                var observer = new IntersectionObserver(function (entries) {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting) {
                            var children = $(element).find(">*");
                            children.each(function (index) {
                                var child = $(this);
                                if (!child.hasClass("slide-up") && !child.hasClass("no-animation")) {
                                    child.addClass("slide-up");
                                    if (windowWidth > 767) {
                                        child.css("animationDelay", (index * 100) + "ms");
                                    }
                                }
                            });
                            $(element).addClass("animated");
                            observer.unobserve(element);
                        }
                    });
                });
                observer.observe(element);
            }
        });


        // Animate .chart-bar when in viewport
        $(".chart-bar").each(function () {
            if ($(this).isInViewport() && !$(this).hasClass("animate")) {
                $(this).addClass("animate");
            }
        });
    }

    function handleAccordionAnimation() {


        $(".accordion-animation").each(function () {
            if (windowWidth < 841) {
                return;
            }
            var element = this;
            if (!$(element).hasClass("animated")) {
                var observer = new IntersectionObserver(function (entries) {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting) {
                            setTimeout(function () {
                                $(element).addClass("animate");
                                $(element).find(".body").slideDown();
                                $(element).addClass("animated");
                                observer.unobserve(element);
                            }, 500);
                        }
                    });
                });
                observer.observe(element);
            }
        });

        if (windowWidth < 841) {
            var firstAccordion = $(".accordion-animation").first();
            if (firstAccordion.length > 0) {
                $(firstAccordion).addClass("animate");
                $(firstAccordion).find(".body").slideDown();
                $(firstAccordion).addClass("animated");
            }

            $(window).on("scroll", function () {
                $(".accordion-animation").not(":first").each(function () {
                    var element = this;
                    var elementTop = $(element).offset().top + 200;
                    var scrollTop = $(window).scrollTop() + $(window).height();

                    if((scrollTop > elementTop && !$(element).hasClass("animated"))) {
                        $(element).addClass("animate");
                        $(element).find(".body").slideDown();
                        $(element).addClass("animated");
                    }
                });
            });
        }
    }

    function handleTabs() {
        $(".tab-link").on("click", function () {
            var tabId = $(this).data("tab");
            $(this).siblings().removeClass("active");
            $(this).addClass("active");

            $(".tab-content").removeClass("active");
            $("#tab-" + tabId).addClass("active");

            setTimeout(function () {
                animateValues();
            }, 1000);
        });
    }

    function handleReadMore() {
        $(".read-more").on("click", function (e) {
            e.preventDefault();
            var content = $(this).parent().find(".read-more-content");
            content.slideToggle();
            $(this).toggleClass("expanded");
        });
    }

    function handleAddChartAnimation() {
        var chart = $(".add-chart");

        if (chart.length === 0) {
            return;
        }

        chart.each(function () {
            var element = this;
            if (!$(element).hasClass("animated")) {
                var observer = new IntersectionObserver(function (entries) {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting) {
                            $(element).addClass("animate");
                            observer.unobserve(element);
                        }
                    });
                });
                observer.observe(element);
            }
        });
    }

    resizeNumericValues();
    resizeGallery();
    dividendCart();
    gotoSectionNavigaion();
    homepage();
    sustainabilityTables();
    mobileAccordion();
    handleNavOnScroll();
    handleHomeBanner();
    handleAIPage();
    handleMobileStickySideNav();
    handleStickySideNavToggle();
    handleHeights();
    handleSlideUpAnimation();
    handleTabs();
    handleReadMore();
    handleAddChartAnimation();
    handleAccordionAnimation();

    if (windowWidth > 840) {
        setupAnimatedValues();
    }

    $(window).on("scroll", function () {
        handleNavOnScroll();
        animateValues();
        handleSideNav();
        handleMobileStickySideNav();
        handleSlideUpAnimation();
        handleAddChartAnimation();
        handleAccordionAnimation();
    });

    $(window).on('resize', function () {
        sustainabilityTables();
        homepage();
        progressingPage();
        handleAIPage();
        handleSideNav();
        handleMobileStickySideNav();
        handleHeights();
    });

    setTimeout(function () {
        homepage();
        resizeGalleryImage();
        progressingPage();
        animateValues();
    }, 1000);
});
